angular.module("Main").directive("auto-focus", function ($timeout) {

    return {
        restrict: 'AC',
        link: function(_scope, _element) {

            $timeout(function(){
                window.focus();
                _element[0].focus();
            }, 0);
        }
    };
});